import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { GridComponent, QueryCellInfoEventArgs } from '@syncfusion/ej2-angular-grids';
import { TooltipComponent } from '@syncfusion/ej2-angular-popups';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { IContactCompany, IContactDetail } from '../../shared/models/index';
import { CompanyContactService, StorageManagerService } from '../../shared/services/index';
import { ContactDetailComponent, ERFormComponent, LCRFormComponent } from '../index';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss'],
    standalone: false
})
export class ContactComponent implements OnInit, OnDestroy {

    @ViewChild('contactDetail') contactDetailComponent: ContactDetailComponent;
    @Input() contactHistory_grid_data: IContactDetail[];
    @Input() company_grid_data: IContactCompany[];
    public initialPage: Object;
    public sortOptions: Object;
    contact: IContactDetail;
    contactId: string;
    contactRevisionId: string;
    loading = false;
    errorMessage: string;
    isNewContact = false;
  referrerUrl: string;
  sub: Subscription;

  @ViewChild('tooltipCompany') tooltipCompany: TooltipComponent;
  @ViewChild('tooltipContact') tooltipContact: TooltipComponent;

  @ViewChild('contactHistoryGrid') contactHistoryGrid: GridComponent;
  @ViewChild('company_grid') company_grid: GridComponent;

  public clipmodecolumn = { class: 'e-tooltipcolumn' };

  @Input() parentComponentInput: LCRFormComponent | ERFormComponent;
  @Output() cancelButtonClickedOutput = new EventEmitter<any>();
  @Output() contactOutput = new EventEmitter<any>();
  @Output() contactRetrievedOutput = new EventEmitter<any>();

    constructor(
        private activatedRoute: ActivatedRoute, private storageManagerService: StorageManagerService,
        private router: Router, private toastr: ToastrService,
        private contactService: CompanyContactService, private sanitizer: DomSanitizer) { }


    ngOnInit(): void {
        this.sortOptions = {
            columns: [{ field: 'companyName', direction: 'Ascending' }]
        };

        sessionStorage['tab'] = 'contact';
        this.initialPage = { currentPage: 1, pageSize: 25, pageSizes: [25, 50, 75, 100, 'All'] };

        // Get Contact detail
        this.getContactRevisionId();
        if (!this.isNewContact) {
            this.getContactRevisionHistory();
            this.getContactById(this.contactRevisionId);
      }

      this.activatedRoute.queryParams.subscribe( ref => {
        this.referrerUrl = ref['referrerUrl'];
      });
  }

  tooltipValue(args) {

    let grid;
    let currentGridId;
    let tooltip: TooltipComponent;

    currentGridId = args.event.currentTarget.firstChild.id;

    if (args.target.scrollWidth <= args.target.clientWidth) {
      args.cancel = true;
    } else {

      if (currentGridId) {
        switch (currentGridId) {
          case 'contactHistoryGrid':
            grid = this.contactHistoryGrid;
            tooltip = this.tooltipContact;
            break;
          case 'company_grid':
            grid = this.company_grid;
            tooltip = this.tooltipCompany;
            break;
        }

        const rowInfo = grid.getRowInfo(args.target);
        const rowData = rowInfo.rowData;
        tooltip.cssClass = 'customTooltip';
        tooltip.content = rowData[(rowInfo.column as any).field];
      }
    }
  }


    // Format "Version" column on company history grid
    customizeCell(args: QueryCellInfoEventArgs) {
        if (args.column.field === 'version') {
            if (args.data['activeFlagFormatted'] === 'Active') {
                args.cell.innerHTML = args.data['version'] + '&nbsp;<span class="label label-success">current</span>';

            }
        }
    }

  getContactRevisionId() {

    if (!this.parentComponentInput) {
      this.contactRevisionId = this.activatedRoute.snapshot.params.contactRevisionId;
      if (!this.contactRevisionId) {
        this.isNewContact = true;
      }
    }
  }

  getContactById(contactRevisionId: string): void {

      if (contactRevisionId) {
        this.contactService.getContactById(contactRevisionId).subscribe(data => {
          if (data) {
              this.contact = data['contactDetail'];
              this.contactId = this.contact.contactId;
            this.company_grid_data = data['associatedCompanies'];
          }
      },
          error => {
            this.toastr.error(error && error.errorMessage ? error.errorMessage : error);
          }
      );
      }
    }

    // Display detail of a single company
    viewCompany(companyRevisionId: string, companyId: string) {
        if (companyRevisionId) {
            sessionStorage['currentCompanyId'] = companyId;
            this.router.navigate(['/company-details', companyRevisionId]);
        }
    }

    // Display detail of a single contact
    viewContact(contactRevisionId: string, contactId: string) {
        if (contactRevisionId) {
            // sessionStorage['currentContactId'] = contactId;
            // reload with new data
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
                this.router.navigate(['/contact', contactRevisionId]));
        }
    }

  cancelBtnClicked() {

    if (!this.parentComponentInput) {

      this.router.navigateByUrl('/company-contact-maintenance');
    } else {

      this.cancelButtonClickedOutput.emit();
    }
  }
    // Retrieve historical contact records
  getContactRevisionHistory(): void {

    if (this.contactRevisionId) {
      this.contactService.getContactRevisionHistory(Number(this.contactRevisionId)).subscribe(data => {
        if (data) {
          this.contactHistory_grid_data = data;
        }
      },
        error => {
          this.toastr.error(error && error.errorMessage ? error.errorMessage : error);
        }
      );
    }
  }

  savedContact(contact) {
    this.contactOutput.emit(contact);
  }

  contactRetrieved(contact) {
    this.contactRetrievedOutput.emit(contact);
  }

  ngOnDestroy(): void {

    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}


